const fileExistsOnServer = fileOverview => fileOverview.serverId

export default fileExistsOnServer